import React from 'react';
import Navbar from '../../components/Home/Navbar/Navbar';
import LibraryList from "../../components/Library/Library";

const Library = () => {
return (
    <div>
        <Navbar />
        <LibraryList />
    </div>
);
};

export default Library;